<template>
  <div>
    <div class="logo">
      <img src="../images/logo.png" alt="logo" />
    </div>
    <div class="title">
      <h2>Financial Summary for BRF</h2>
    </div>
    <h3>
      Finnancial information based on Mar2022/2021(last 12 months,unit USD$
      Million
    </h3>
    <div class="item1">
      <div class="left">
        <p>Pros:</p>
        <ul style="margin-bottom: 34px">
          <li>
            Large and incresed size : $12Bn total assets and $2.7Bn net worth in
            Mar 2022
          </li>
          <li>
            Incresed revenue by 44% to $10.5Bn, incresed gross profit,EBITDA and
            EBIT
          </li>
        </ul>
        <p>Cons:</p>
        <ul>
          <li>Decreased net income to negative of-$245M</li>
          <li>Decreased liquidity capacity</li>
          <li>Increased debts amount facing the solvency pressure</li>
        </ul>
      </div>
      <div class="right">
        <img src="../images/img1.png" />
      </div>
    </div>
    <h3>Main financial Ratio Mar 2022/2021 (LTM)</h3>
    <div class="item2">
      <img src="../images/img8.png" alt="img" />
      <img src="../images/img6.png" alt="img" />
      <img src="../images/img3.png" alt="img" />
      <img src="../images/img4.png" alt="img" />
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style scoped lang="scss">
.logo {
  padding-top: 20px;
  text-align: right;
}
.title {
  font-size: 24px;
  color: #3a3f63;
  line-height: 24px;
  padding: 20px 0;
  text-align: center;
  border-bottom: 4px solid #3a3f63;
}
h3 {
  font-size: 16px;
  line-height: 19px;
  color: #ffb243;
  text-align: center;
  margin: 34px 0 24px 0;
}

.item1 {
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 16px;

  font-size: 14px;
  color: #3a3f63;
  border: 1px solid #e3e7f2;

  p {
    padding-bottom: 20px;
  }

  ul {
    padding-left: 10px;
  }
  li {
    list-style: inside;
    line-height: 30px;
  }
}
@media screen and (min-width: 1230px) and (max-width: 1450px) {
  .item1 {
    .left {
      width: 390px;
    }
    .right {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    li {
      line-height: 20px;
    }
    p {
      padding-bottom: 10px;
    }
  }
}
@media only screen and (max-width: 1230px) {
  .item1 {
    display: block;

    .left {
      margin-bottom: 30px;
    }
  }
}

.item2 {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;

  img {
    margin-bottom: 30px;
  }
}
</style>
